import React from 'react';
import { Play, Check } from 'lucide-react';
import { useLanguage } from '../../../language/hooks/useLanguageHook';
import { finalCtaFeatures } from '../../data/landingPageData'; // Import data

const FinalCtaSection = ({ onStartFreeTrial, onOpenVideoModal }) => {
  const { t } = useLanguage();

  return (
    <div className="relative z-10 bg-gradient-to-r from-blue-600 to-blue-800 scroll-fade-in">
      <div className="max-w-7xl mx-auto px-6 py-24">
        {/* Use a slightly transparent background for the inner box */}
        <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-12 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            {t("public.landing.finalCta.title.line1")}
            <br />
            <span className="text-blue-200">{t("public.landing.finalCta.title.line2")}</span>
          </h2>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            {t("public.landing.finalCta.subtitle")}
          </p>
          <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-6">
            <button
              onClick={onStartFreeTrial} // Use prop
              className="bg-white text-blue-600 px-10 py-4 md:px-12 md:py-5 rounded-lg hover:bg-blue-50 transition-all duration-300 ease-in-out transform hover:scale-105 hover:shadow-xl text-lg font-semibold w-full sm:w-auto"
            >
              {t("public.landing.finalCta.buttons.trial")}
            </button>
            <button
              onClick={onOpenVideoModal} // Use prop
              className="text-white border-2 border-white/30 px-10 py-4 md:px-12 md:py-5 rounded-lg hover:bg-white/20 transition-all duration-300 ease-in-out text-lg font-semibold w-full sm:w-auto flex items-center justify-center"
            >
              <Play className="h-5 w-5 mr-2" />
              {t("public.landing.finalCta.buttons.demo")}
            </button>
          </div>
          <div className="mt-8 flex flex-col sm:flex-row justify-center items-center space-y-2 sm:space-y-0 sm:space-x-8 text-blue-100">
            {finalCtaFeatures.map((featureKey) => (
              <div key={featureKey} className="flex items-center">
                <Check className="h-5 w-5 mr-2" />
                {t(featureKey)}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinalCtaSection; 